import React, { useEffect, useState } from "react";
import { MenuSelect } from "../components/Form";
import { TbUser } from "react-icons/tb";
import { AiOutlinePoweroff } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import NotificationComp from "../components/NotificationComp";
import { useNavigate } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import MenuDrawer from "../components/Drawer/MenuDrawer";
import { setUser } from "../redux/features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import bookingApi from "../api/booking/BookingApi";
import staffApi from "../api/user/staff.api";
import userApi from "../api/user/user.api";
import dayjs from "dayjs";
import toast from "react-hot-toast";

function Header() {
  const [isOpen, setIsOpen] = React.useState(false);
  const { user } = useSelector((state) => state.user);
  // console.log({ user });

  // toggle drawer
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [bookings, setBookings] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          { response: bookingsRes },
          { response: staffRes },
          { response: usersRes },
        ] = await Promise.all([
          bookingApi.getAllBookings(),
          staffApi.getAllStaffInfo(),
          userApi.getAllUsers(),
        ]);

        if (bookingsRes?.data?.booking) setBookings(bookingsRes.data.booking);
        if (staffRes?.data?.data) setStaffs(staffRes.data.data);
        if (usersRes?.data) setCustomers(usersRes.data);

        generateNotifications(bookingsRes.data.booking, usersRes.data);
      } catch (error) {
        toast.error("Something went wrong!");
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const generateNotifications = (bookings, customers) => {
    const today = dayjs().startOf("day");
    const notifs = [];

    // Optional: birthdays
    customers.forEach((customer) => {
      if (
        customer.birthday &&
        dayjs(customer.birthday).format("MM-DD") === dayjs().format("MM-DD")
      ) {
        notifs.push({
          id: `birthday-${customer._id}`,
          action: 1,
          user: { title: customer.name },
          time: dayjs().format("hh:mm A"),
          read: false,
        });
      }
    });

    // ✅ All bookings from today into the future
    bookings.forEach((booking) => {
      const bookingDate = dayjs(booking.selectedDateTime);

      if (bookingDate.isSame(today, "day") || bookingDate.isAfter(today)) {
        notifs.push({
          _id: booking._id,
          action: 2,
          user: { title: booking.customer_info?.name || "Customer" },
          time: bookingDate.format("dddd, MMM D • hh:mm A"),
          sortTime: bookingDate.toISOString(),
          read: false,
        });
      }
    });

    // Sort by time ascending
    notifs.sort(
      (a, b) => new Date(a.sortTime || a.time) - new Date(b.sortTime || b.time),
    );

    setNotifications(notifs);
  };

  // console.log({ notifications });

  // console.log({ bookings });

  // console.log({ customers });

  const DropDown1 = [
    {
      title: "Profile",
      icon: TbUser,
      onClick: () => {
        navigate("/settings");
      },
    },
    {
      title: "Logout",
      icon: AiOutlinePoweroff,
      onClick: () => {
        dispatch(setUser(null)); // or dispatch(logoutUser()) if you have a logout action
        navigate("/login");
      },
    },
  ];

  return (
    <>
      <MenuDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} />
      {/* cmp */}
      <div className="xl:w-5/6 w-full 2xl:max-w-[2000px] bg-navy grid md:grid-cols-2 grid-cols-12 items-center bg-opacity-95 fixed top-0 z-40 xs:px-8 px-2">
        <div className="md:col-span-1 sm:col-span-11 col-span-10 flex gap-4 items-center md:py-0 py-4">
          <button
            onClick={toggleDrawer}
            className="block xl:hidden bg-navy text-yellowstar text-2xl border border-yellowstar w-16 md:w-12 h-12 rounded-md flex-colo transitions "
          >
            <BiMenu />
          </button>
          {/* search */}
          <MenuSelect datas={DropDown1}>
            <div className="flex gap-4 items-center p-0 rounded-lg lg:p-4">
              <img
                src={user?.photo}
                alt="user"
                className="w-12 border border-border object-cover h-12 rounded-full border border-yellowlight"
              />
              <div className="flex flex-col items-start">
                <p className="text-textGray hidden sm:block">Welcome</p>
                <div className="text-text lg:flex gap-2 md:flex md:flex-colo ">
                  <h1 className="text-yellowlight font-bold">{user?.name}</h1>
                  <h1 className="text-yellowlight">{user?.town}</h1>
                </div>
              </div>
            </div>
          </MenuSelect>
        </div>
        <div className="md:col-span-1 sm:col-span-1 col-span-2 items-center justify-end pr-4 md:pr-0">
          <div className="float-right flex gap-4 items-center justify-center">
            <NotificationComp datas={notifications}>
              <div className="relative">
                <MdOutlineNotificationsNone className="text-2xl hover:text-subMain text-textGray" />
                {notifications.filter((n) => !n.read).length > 0 && (
                  <span className="absolute -top-2.5 -right-2.5 font-semibold bg-subMain rounded-full px-1.5 py-0.5 text-xs text-white text-center">
                    {notifications.filter((n) => !n.read).length}
                  </span>
                )}
              </div>
            </NotificationComp>

            <div className=" items-center md:flex hidden">
              {/* <MenuSelect datas={DropDown1}>
                <div className="flex gap-4 items-center p-4 rounded-lg">
                  <img
                    src={user?.photo}
                    alt="user"
                    className="w-12 border border-border object-cover h-12 rounded-full border border-yellowlight"
                  />
                  <p className="text-sm text-text font-medium ">Dr. Daudi</p>
                </div>
              </MenuSelect> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
